import Vue from "vue";
import VueRouter from "vue-router";
// import TokenService from "../services/storage.service.js";
import store from "@/store";

// const $tokenService = new TokenService();

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "app",
		component: () => import(/* webpackChunkName: "about" */ "../views/App.vue"),
		meta: { requiresAuth: true },
	},
	{
		path: "",
		name: "frontpage",
		component: () => import("@/views/frontpage/Layout.vue"),
		children: [
			{
				path: "login",
				name: "login",
				props: {
					title: 'Welcome',
					subtitle: 'Enter your credentials to login',
				},
				component: () => import("../views/frontpage/login/Login.vue"),
			},
			{
				path: "login/2FA",
				name: "LoginWith2FA",
				props: {
					title: 'Two-factor authentication',
					subtitle: 'Please enter the code from the two-factor authentication application on your phone.',
				},
				component: () => import("../views/frontpage/login/2FA.vue"),
			},
			{
				path: "login/2FA-recovery",
				name: "LoginWith2FARecovery",
				props: {
					title: 'Two-factor authentication',
					subtitle: 'Please enter the one of the recovery codes from the list you have downloaded during two-factor authentication activation process.',
				},
				component: () => import("../views/frontpage/login/2FARecovery.vue"),
			},
			{
				path: "register/:product?",
				name: "register",
				props: {
					title: 'Sign up to get started',
					subtitle: 'Fill out your details to sign up',
				},
				component: () => import(/* webpackChunkName: "about" */ "../views/frontpage/register/Register.vue"),
			},
			{
				path: "verify-email",
				name: "verify-email",
				props: {
					title: 'Check your inbox',
					subtitle: 'We sent you an activation link. Please be sure to check your spam folder too.',
				},
				component: () => import(/* webpackChunkName: "about" */ "../views/frontpage/register/VerifyEmail.vue"),
			},
			{
				path: "forgot-password",
				name: "ForgotPassword",
				props: {
					title: 'Reset Password',
					backToLoginButton: true
				},
				component: () => import("../views/frontpage/reset/ForgotPassword.vue"),
			},
			{
				path: "forgot-password/2FA",
				name: "ForgotPasswordWith2FA",
				props: {
					title: 'Two-factor authentication',
					subtitle: 'Please enter the code from the two-factor authentication application on your phone.',
					backToLoginButton: true
				},
				component: () => import("../views/frontpage/reset/ForgotPassword2FA.vue"),
			},
			{
				path: "forgot-password/sent",
				name: "ForgotPassword.EmailSent",
				props: {
					title: 'If the provided email exists in our system you should receive a reset password link.',
					subtitle: 'Please click the link in email to reset your password.',
					backToLoginButton: true
				},
			},
			{
				path: "/password/reset",
				name: "PasswordReset",
				props: {
					title: 'Reset your password',
					backToLoginButton: true
				},
				component: () => import("../views/frontpage/reset/ResetPassword.vue"),
			},
		],
	},

	{
		path: "/signout",
		name: "signout",
		component: () => import("@/components/auth/Signout.vue"),
	},

	// Account
	{
		path: "/account",
		name: "account",
		meta: { requiresAuth: true },
		component: () => import("@/views/account/Layout.vue"),
		children: [
			{
				path: "profile",
				name: "account.profile",
				component: () => import("@/views/account/profile/Index.vue"),
			},
			{
				path: "users",
				name: "account.users",
				component: () => import("@/views/account/users/Index.vue"),
			},
			{
				path: "guests",
				name: "account.guests",
				component: () => import("@/views/account/guests/Index.vue"),
			},
			{
				path: "groups",
				name: "account.groups",
				component: () => import("@/views/account/groups/Index.vue"),
			},
			{
				path: "billing",
				name: "account.billing",
				component: () => import("@/views/account/billing/Index.vue"),
			},
			{
				path: "change-plan",
				name: "account.billing.changePlan",
				component: () => import("@/views/account/billing/ChangePlan/Index.vue"),
			},
			{
				path: "projects",
				name: "account.projects",
				component: () => import("@/views/account/projects/Index.vue"),
			},
			{
				path: "security",
				name: "account.security",
				component: () => import("@/views/account/security/Index.vue"),
			},
			{
				path: "notifications",
				name: "account.notifications",
				component: () => import("@/views/account/notifications/Index.vue"),
			},
		],
	},

	// Onboarding
	{
		path: "/onboarding",
		name: "onboarding",
		meta: { requiresAuth: true },
		component: () => import("@/views/onboarding/Layout.vue"),
		children: [
			{
				path: "get-started",
				name: "onboarding.get-started",
				component: () => import("@/views/onboarding/GetStarted.vue"),
				meta: { displayCancelButton: true },
			},
			{
				path: "organization",
				name: "onboarding.organization",
				component: () => import("@/views/onboarding/Organization.vue"),
			},
			{
				path: "invite",
				name: "onboarding.invite",
				props: true,
				component: () => import("@/views/onboarding/Invite.vue"),
			},

			// accepting invitation for non-existing users
			{
				path: "/invitation/accept",
				name: "invitation.accept",
				meta: { requiresAuth: false },
				component: () => import("../views/onboarding/invitation/AcceptInvitation.vue"),
			},

			// accepting invitation for existing user, not logged-in
			{
				path: "/invitation",
				name: "accept.account.frontpage",
				meta: { requiresAuth: false },
				component: () => import("../views/onboarding/invitation/AcceptAccountFrontpage.vue"),
			},
		],
	},

	// accepting invitation for existing user, logged-in
	{
		path: "/accept/account",
		name: "accept.account",
		component: () => import("../views/onboarding/invitation/AcceptAccount.vue"),
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	// redirected from fylm.ai lite
	if (to.query.token && to.name !== "PasswordReset") {
		Vue.prototype.$tokenService.saveToken(to.query.token);
		localStorage.setItem('refreshToken', true);
		if (to.query.product) localStorage.setItem('selected_product', to.query.product);
		delete to.query.token;
		next({name: 'login'});
		return;
	}

	if (to.name == "accept.account") {
		// When accepting invitation while logged in
		if (Vue.prototype.$tokenService.getToken() && !store.state.User.user) next();
		else next({ name: "accept.account.frontpage", query: to.query });
		return;
	}

	// When accepting invitation, but not logged in
	else if (to.name == "accept.account.frontpage") {
		next();
		return;
	}

	// When creating account by invitation
	else if (to.name == "invitation.accept") {
		next();
		return;
	}

	// When signing out
	else if (to.name == "signout") {
		next();
		return;
	}

	// When reloading the app, if token exists fetch user first
	else if (Vue.prototype.$tokenService.getToken() && !store.state.User.user) {
		store.dispatch("resetData");
		Vue.prototype.$apiService.setBearer();
		Vue.prototype.$apiService.mountInterceptor401();

		store.dispatch("Auth/auth").then(authenticated => {
			if (!authenticated) {
				store.dispatch("resetAll");
				next({ name: "login" });
				return;
			}

			const user = store.state.User.user;
			const account = store.state.User.account;

			if (account.plan_id > 6) {
				let token = Vue.prototype.$tokenService.getToken();
				window.location.replace(`${window.FYLM_LITE_APP_URL}?token=${token}`)
			}

			if (user && !user.email_verified_at) {
				if (to.name !== "verify-email") {
					next({ name: "verify-email" });
				} else {
					next();
				}
			} else if (user && user.email_verified_at && account.onboarding == null) {
				next({ name: "onboarding.get-started" });
			} else if (user && user.email_verified_at && account.onboarding == "get_started") {
				next({ name: "onboarding.organization" });
			} else if (user && user.email_verified_at && account.onboarding == "organization" && account.plan_id != 1) {
				next({ name: "onboarding.invite" });
			} else if (
				user &&
				user.email_verified_at &&
				account.onboarding == "completed" &&
				(to.name == "onboarding.get-started" || to.name == "onboarding.organization" || to.name == "onboarding.invite")
			) {
				next({ name: "app" });
			} else if (user && user.email_verified_at && to.name == "verify-email") {
				next({ name: "app" });
			} else if (!requiresAuth) {
				if (to.name == 'register' && to.params.plan) {
					localStorage.setItem('selected_product', to.params.plan);
				}

				// redirect to app when trying to access public pages while logged in
				next({ name: "app" });
			} else {
				next();
			}
		});
	} else if (requiresAuth) {
		const user = store.state.User.user;
		const account = store.state.User.account;

		store.dispatch("Dashboard/resetState"); // NOTE: refactor this

		if (user && user.email_verified_at) {
			if (!account.onboarding) {
				if (to.name == "onboarding.get-started") next();
				else if (to.name == "onboarding.organization" && account.plan_id == store.state.Plans.PLAN_FREE.id) next();
				else next({ name: "onboarding.get-started" });
			} else if (account.onboarding == "get_started" && (to.name == "onboarding.get-started" || to.name == "onboarding.invite")) {
				next({ name: "onboarding.organization" });
			} else if (
				account.onboarding == "organization" &&
				account.plan_id != 1 &&
				(to.name == "onboarding.get-started" || to.name == "onboarding.organization")
			) {
				next({ name: "onboarding.invite" });
			} else if (
				account.onboarding == "completed" &&
				(to.name == "onboarding.get-started" || to.name == "onboarding.organization" || to.name == "onboarding.invite")
			) {
				next({ name: "app" });
			} else {
				next();
			}
		} else if (!user) {
			store.dispatch("resetAll");
			next({ name: "login" });
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
